import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { toast, Toaster } from "sonner";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { Loader2, KeyRound } from "lucide-react";

const OWL_LOGO = "https://customer-assets-39nsmqrw.emergentagent.net/job_gts-attendance/artifacts/ju2vrway_LOGO%20IEC.png";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) { toast.error("Password minimal 6 karakter"); return; }
    if (nw !== confirm) { toast.error("Konfirmasi password tidak cocok"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: nw });
      setDone(true);
      toast.success("Password berhasil diubah. Silakan login.");
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gtscream p-6" data-testid="reset-page">
      <Toaster position="top-center" richColors />
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_8px_30px_rgb(16,42,86,0.08)] p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="w-16 h-16 rounded-3xl bg-white flex items-center justify-center mb-3 p-1 border">
            <img src={OWL_LOGO} alt="IEC Mustikajaya" className="w-full h-full object-contain" />
          </div>
          <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Buat Password Baru</h2>
          <p className="text-sm text-muted-foreground">GTS IEC Mustikajaya</p>
        </div>

        {!token ? (
          <p className="text-center text-rose-600 text-sm" data-testid="reset-no-token">Tautan tidak valid. Silakan minta tautan reset kembali dari halaman login.</p>
        ) : done ? (
          <p className="text-center text-emerald-600 text-sm" data-testid="reset-done">Password berhasil diubah. Mengarahkan ke halaman login...</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Password Baru</Label>
              <PasswordInput value={nw} onChange={(e) => setNw(e.target.value)} className="rounded-xl mt-1" testid="reset-new-pw" />
            </div>
            <div>
              <Label>Konfirmasi Password Baru</Label>
              <PasswordInput value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-xl mt-1" testid="reset-confirm-pw" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full bg-gradient-to-r from-gtsorange to-gtsorange-light text-white font-semibold h-11 gap-2" data-testid="reset-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Simpan Password Baru
            </Button>
          </form>
        )}
        <button onClick={() => navigate("/login")} className="w-full text-center text-xs text-gtsorange hover:underline mt-5" data-testid="reset-back-login">
          Kembali ke Login
        </button>
      </div>
    </div>
  );
}
